import React from "react";
import { GraphAttachment } from "../../../../redux/outlook/outlook.types";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { getExtension } from "../../../../helpers";

export const getAttachmentIcon = (attachment: GraphAttachment) => {
  const contentType = (attachment.contentType || "").toLowerCase();
  const extension = getExtension(attachment.name || "");

  if (contentType.includes("pdf") || extension === "pdf") {
    return <PictureAsPdfOutlinedIcon color="error" />;
  }

  if (
    contentType.startsWith("image/") ||
    ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension)
  ) {
    return <ImageOutlinedIcon color="primary" />;
  }

  if (["xls", "xlsx", "csv"].includes(extension)) {
    return <TableChartOutlinedIcon color="success" />;
  }

  if (["ppt", "pptx"].includes(extension)) {
    return <SlideshowOutlinedIcon color="warning" />;
  }

  if (
    contentType.includes("word") ||
    ["doc", "docx", "txt", "rtf"].includes(extension)
  ) {
    return <DescriptionOutlinedIcon color="action" />;
  }

  return <InsertDriveFileOutlinedIcon color="action" />;
};
